export default (session) => {
    // hard-coded preview session data
    const PREVIEW_NA = 'Preview N/A';

    session.userData = {
        firstName: PREVIEW_NA,
        lastName: PREVIEW_NA,
        email: PREVIEW_NA,
        userID: PREVIEW_NA,
        accountID: PREVIEW_NA,
        parentID: PREVIEW_NA,
        groupID: PREVIEW_NA,
        plan: PREVIEW_NA,
        ipAddress: PREVIEW_NA,
        permission: PREVIEW_NA,
        isAdminOrParentAdmin: false,
        isIntegrationsEnabled: true,
        features: {
            EMAIL_DESIGNER_LATEST: true,
            EMAIL_DESIGNER_CORE: true,
            EMAIL_DESIGNER_STYLING_ACCESS: true,
            EMAIL_DESIGNER_VERSION_HISTORY: false,
            EMAIL_DESIGNER_CUSTOMIZATION: false,
            EMAIL_DESIGNER_CUSTOM_FONTS: false,
            EMAIL_DESIGNER_RAW_IMAGE_UPLOA: false,
            EMAIL_DESIGNER_PERSONALIZATION: false,
            CONTENT_LIBRARY_ACCESS: false,
            SURVEY_SOCIAL_REACTIONS: true,
            SURVEY_ENPS: true,
            SURVEYS_PULSE_CUSTOM: true,
            SURVEYS_PULSE_PRESET: true,
        },
    };
    session.features = {
        F_ELEMENT_VIDEO: false,
        F_EDIT_HTML: false,
        F_IMAGE_LIBRARY: false,
        F_IMAGE_UPLOAD: false,
        F_COLOR_PALETTE: false,
        F_PREVIEW: false,
        F_DOWNLOAD_PDF: false,
        F_DOWNLOAD_HTML: false,
        F_SEND_TEST_EMAIL: false,
        F_SHARE_DRAFT: false,
        F_CUSTOM_FONTS: false,
        F_RTE: false,
        F_SUPPORT: false,
        F_ELEMENT_TOC: false,
        F_FEEDBACK: false,
        F_TUTORIALS: false,
        F_SAVE: false,
        F_SAVE_AS_TEMPLATE: false,
        F_VERSION_HISTORY: false,
    };
    session.collaboration = {
        connectedClients: [],
        currentUserSocketId: '',
        domain: 'bananatag',
        id: '',
        trackID: '',
        versionID: '',
        type: 'draft',
        access: 'owner',
        isConnected: false,
        hasStaffbaseAccount: false,
    };
    session.controls = [];
    session.authorization = '';
    session.integration = 'PUBLIC_PREVIEW';

    return session;
};
